module.exports = __webpack_public_path__ + "static/media/lofiPlace.10aa4845.gif";